<form [formGroup]="medicoForm" (submit)="crearMedico(medicoForm.value)" class="formCard">
    <div class="tituloModal">
        <span>
            Crear médico
        </span>
        <mat-icon class="buttonClose" [mat-dialog-close]=false>close</mat-icon>
    </div>
    <div class="textModal">
        <!-- Título, Nombre y Apellido -->
        <div class="formGroup documento">
            <div class="tipoDocumento">
                <mat-form-field appearance="fill" class="input" style="width: 120px;">
                    <mat-label>Título</mat-label>
                    <mat-select formControlName="title">
                        <mat-option value="Dr">Dr</mat-option>
                        <mat-option value="Dra">Dra</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="valid">
                    <span style="color:rgb(236,75,72);" *ngIf="medicoForm.get('title').errors?.required && medicoForm.get('title').touched">
                        El título es requerido
                    </span>
                </div>
            </div>
            <div class="numeroDocumento" style="flex: 1;">
                <mat-form-field class="example-full-width input" appearance="fill">
                    <mat-label>Nombre</mat-label>
                    <input formControlName="name" type="text" matInput>
                </mat-form-field>
                <div class="valid">
                    <span style="color:rgb(236,75,72);" *ngIf="medicoForm.get('name').errors?.required && medicoForm.get('name').touched">
                        El nombre es requerido
                    </span>
                </div>
            </div>
            <div class="numeroDocumento" style="flex: 1;">
                <mat-form-field class="example-full-width input" appearance="fill">
                    <mat-label>Apellido</mat-label>
                    <input formControlName="surname" type="text" matInput>
                </mat-form-field>
                <div class="valid">
                    <span style="color:rgb(236,75,72);" *ngIf="medicoForm.get('surname').errors?.required && medicoForm.get('surname').touched">
                        El apellido es requerido
                    </span>
                </div>
            </div>
        </div>
        <div>
            <div class="formGroup documento">
                <div class="tipoDocumento">
                    <mat-form-field appearance="fill" class="input input1">
                        <mat-label>Tipo documento</mat-label>
                        <mat-select formControlName="tipoDocumento">
                            <mat-option *ngFor="let tipoDoc of tiposDocumentos" [value]="tipoDoc.id">{{tipoDoc.texto}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="valid">
                        <span style="color:rgb(236,75,72);" *ngIf="errorTipoDocumento">
                            El tipo de documento es requerido con el numero de documento
                        </span>
                    </div> 
                </div>
                <div class="numeroDocumento">
                    <mat-form-field class="example-full-width input input2" appearance="fill">
                        <mat-label>Número documento</mat-label>
                        <input formControlName="numeroDocumento" (ngModelChange)="clearNumeroDocumento()" type="text" matInput>
                    </mat-form-field>
                    <div class="valid">
                        <span style="color:rgb(236,75,72);" *ngIf="errorNumeroDocumento">
                            El número de documento es requerido con el tipo de documento
                        </span>
                    </div> 
                </div>
            </div>
            <span style="color:rgb(236,75,72);" *ngIf="errorDocumento">
                Este tipo y número de documento fue registrado para otro médico
            </span>
        </div>
        <div class="formGroup">
            <mat-form-field class="formFile"> 
                <div class="myfilebrowser">
                  <mat-toolbar>
                    <input matInput [(ngModel)]="myfilename" readonly formControlName="memberContactNo" />
                    <button mat-raised-button class="fileButton" color="primary">
                      Buscar
                    </button>
                  </mat-toolbar>
                  <input type="button" #UploadFileInput id="fileUpload" (click)="openDialogFoto()" name="fileUpload"
                      accept="image/*" />
                </div>
            </mat-form-field>
            <div class="divText">
                <span class="textAclaration">Imagen debe contar con el mismo alto y ancho, max 1200*1200</span>
            </div>
        </div>
        <div #divImagen class="divImagen">
            <img class="imagen" #mostrarImagen [src]="imagen">
        </div>
        <div class="formGroup">
            <mat-form-field class="example-full-width input" appearance="fill">
                <mat-label>Matricula</mat-label>
                <input formControlName="matricula" (ngModelChange)="clearMatricula()" type="text" matInput>
            </mat-form-field>
            <div class="valid">
                <span style="color:rgb(236,75,72);" *ngIf="medicoForm.get('matricula').errors?.required && medicoForm.get('matricula').touched">
                    La matricula es requerida
                </span>
                <span style="color:rgb(236,75,72);" *ngIf="errorMatricula && medicoForm.get('matricula').touched">
                    La matricula fue registrada por otro médico
                </span>
            </div>
        </div>
        <!-- Tipo de Licencia y Provincia -->
        <div class="formGroup documento">
            <div class="tipoDocumento">
                <mat-form-field appearance="fill" class="input input1">
                    <mat-label>Tipo de licencia</mat-label>
                    <mat-select formControlName="licenseType">
                        <mat-option value="nacional">Nacional</mat-option>
                        <mat-option value="provincial">Provincial</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="valid">
                    <span style="color:rgb(236,75,72);" *ngIf="medicoForm.get('licenseType').errors?.required && medicoForm.get('licenseType').touched">
                        El tipo de licencia es requerido
                    </span>
                </div>
            </div>
            <div class="numeroDocumento">
                <mat-form-field appearance="fill" class="input input2">
                    <mat-label>Provincia</mat-label>
                    <mat-select formControlName="province">
                        <mat-option value="">-- Sin provincia --</mat-option>
                        <mat-option *ngFor="let prov of provincias" [value]="prov.name">
                            {{ prov.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <!-- Dirección -->
        <div class="formGroup documento">
            <div class="numeroDocumento" style="flex: 2;">
                <mat-form-field class="example-full-width input" appearance="fill">
                    <mat-label>Calle</mat-label>
                    <input formControlName="addressStreet" type="text" matInput>
                </mat-form-field>
            </div>
            <div class="tipoDocumento" style="flex: 1;">
                <mat-form-field class="example-full-width input" appearance="fill">
                    <mat-label>Número</mat-label>
                    <input formControlName="addressNumber" type="text" matInput>
                </mat-form-field>
            </div>
        </div>
        <div class="formGroup">
            <mat-form-field class="example-full-width input" appearance="fill">
                <mat-label>Email</mat-label>
                <input formControlName="email" type="email" (ngModelChange)="clearEmail()" matInput>
            </mat-form-field>
            <div class="valid">
                <span class="advertenciaMensaje" *ngIf="!medicoForm.get('email').value">
                    <mat-icon class="advertenciaIcono">report_problem</mat-icon>Si no se asigna un email, no le llegaran notificaciones que pueden ser importantes
                </span>
                <span style="color:rgb(236,75,72);" *ngIf="medicoForm.get('email').errors?.email && medicoForm.get('email').touched">
                    El email no tiene el formato correcto 
                </span>
                <span style="color:rgb(236,75,72);" *ngIf="errorEmail && medicoForm.get('email').touched">
                    El email fue registrado por otro medico
                </span>
            </div> 
        </div>
        <div class="formGroup telefonoForm">
            <mat-form-field appearance="fill" class="telefonoInput">
                <mat-label>Teléfono país</mat-label>
                <mat-select formControlName="telPais">
                    <mat-option>
                        <ngx-mat-select-search 
                            id="telPaisBuscador" 
                            [noEntriesFoundLabel]="'Not found'" 
                            [placeholderLabel]="'Buscador'" 
                            [formControl]="telPaisBuscador"
                            name="filterPost" 
                            (ngModelChange)="filtrarTelPais()">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let tel of filtroTelefonoPais" [value]="tel.codigo">
                        {{tel.nombre}} ({{tel.codigo}})
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="example-full-width" class="telefonoInput" appearance="fill">
                <mat-label>Teléfono caract.</mat-label>
                <input formControlName="telCaract" type="text" matInput>
            </mat-form-field>
            <mat-form-field class="example-full-width" class="telefonoInput" appearance="fill">
                <mat-label>Teléfono número </mat-label>
                <input formControlName="telNumero" type="text" matInput>
            </mat-form-field>
        </div>
        <div class="formGroup telefonoForm">
            <mat-form-field appearance="fill" class="telefonoInput">
                <mat-label>Celular país</mat-label>
                <mat-select formControlName="celPais">
                    <mat-option>
                        <ngx-mat-select-search 
                            id="celPaisBuscador" 
                            [noEntriesFoundLabel]="'Not found'" 
                            [placeholderLabel]="'Buscador'" 
                            [formControl]="celPaisBuscador"
                            name="filterPost" 
                            (ngModelChange)="filtrarCelPais()">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let tel of filtroCelularPais" [value]="tel.codigo">
                        {{tel.nombre}} ({{tel.codigo}})
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="fill" class="telefonoInput">
                <mat-label>Celular caract.</mat-label>
                <input formControlName="celCaract" type="text" matInput>
            </mat-form-field>
            <mat-form-field class="example-full-width" appearance="fill" class="telefonoInput">
                <mat-label>Celular número</mat-label>
                <input formControlName="celNumero" type="text" matInput>
            </mat-form-field>
        </div>
        <div class="formGroup">
            <mat-form-field class="example-full-width input" appearance="fill">
                <mat-label>Código interno</mat-label>
                <input formControlName="codigoInterno" type="text" matInput>
            </mat-form-field>
        </div>
        <div class="formGroup">
            <mat-form-field class="example-full-width input" appearance="fill">
                <mat-label>Password</mat-label>
                <input formControlName="password" type="password" matInput>
            </mat-form-field>
        </div>
        <div class="formGroup">
            <mat-form-field class="example-full-width input" appearance="fill">
                <mat-label>Repetir password</mat-label>
                <input formControlName="repeatPassword" type="password" matInput>
            </mat-form-field>
            <div class="valid">
                <span style="color:rgb(236,75,72);" *ngIf="medicoForm.hasError('mismatch') && medicoForm.get('repeatPassword').touched">
                    Los passwords no son iguales
                </span>
            </div>
        </div>
        <div class="formGroup formAgenda">
            <div class="agenda">
                <mat-slide-toggle
                    formControlName="agenda"
                    class="example-margin"
                    color="primary"
                    [disabled]="disabled"
                    (change)="cambiarAgenda($event)"
                >
                    Agenda
                </mat-slide-toggle>
            </div>
            <div *ngIf="agenda">
                <input formControlName="color_agenda" type="color">
            </div>
        </div>
        <div class="valid">
            <span style="color:rgb(236,75,72);" *ngIf="errorAgenda">
                Se alcanzo el límite de agendas habilitadas
            </span>
        </div>
        <div class="formGroup listaDias" [ngClass]="{'invisible': !agenda}">
            <app-agenda-form
                *ngIf="agenda"
                [agendaForm]="medicoForm"
            ></app-agenda-form>
        </div>
        <div class="formGroup">
            <mat-slide-toggle
                formControlName="notificaciones"
                class="example-margin"
                color="primary"
                [disabled]="disabled">
                Notificaciones de estudios médicos 
            </mat-slide-toggle>
        </div>
    </div>
    <div class="accionModal">
        <div class="buttons">
            <button mat-raised-button class="button">Crear</button>
        </div>
    </div>
</form>
